var exports = {
  "jw": "MessageThreadChip.module__chip___YjFVcE",
  "nM": "MessageThreadChip.module__row___YjFVcE",
  "UU": "MessageThreadChip.module__name___YjFVcE",
  "U9": "MessageThreadChip.module__count___YjFVcE",
  "VH": "MessageThreadChip.module__preview___YjFVcE",
};

module.exports = exports;
